export const RolesEnum = {
    SUPER_ADMIN: 'Super Admin',
    COO: 'COO',
    EXAMINATION_HEAD: 'Examination Head',
    TEACHER: 'Teacher',
    ADMIN: 'Admin',
    CLASS_INCHARGE: 'Class Incharge',
};

export const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];


export const monthColorMap = {
    "Jan": "#8B0000", // Dark Red
    "Feb": "#800080", // Purple
    "Mar": "#ADD8E6", // Light Blue
    "Apr": "#FFFFFF", // White
    "May": "#008000", // Green
    "Jun": "#9370DB", // Light Purple
    "Jul": "#80461B", // Russet
    "Aug": "#FFA500", // Orange
    "Sep": "#8B4513", // Brown
    "Oct": "#2A52BE", // Cerulean Blue
    "Nov": "#FFD700", // Yellow
    "Dec": "#0000FF"  // Blue
};

export const subjectColorMap = {
    "Mathematics": "#1E90FF",       // Dodger Blue
    "Physics": "#8B0000",           // Dark Red
    "Chemistry": "#FF8C00",         // Dark Orange
    "Biology": "#228B22",           // Forest Green
    "Computer": "#4B0082",          // Indigo
    "English": "#2E8B57",           // Sea Green
    "Urdu": "#006400",              // Dark Green
    "Islamiat": "#556B2F",          // Dark Olive Green
    "Pakistan Studies": "#CD853F",  // Peru
    "Pst": "#CD853F",               // Same as Pakistan Studies
    "Sindhi": "#A0522D",            // Sienna
    // Default color if subject not matched
    "default": "#808080"            // Gray
};


export const StackedBarChartType = {
    RESULTS: "Results",
    ATTENDANCE: "Attendance",
    SUBJECTRESULTS: "Subject Results",
}